module.exports = __webpack_public_path__ + "static/media/document.3449f5d9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/document.svg
// module id = 345
// module chunks = 1